import { RecieveMoneyContainer } from "./RecieveMoney.styles";
import RecieveMoneyLeft from "./RecieveMoneyLeft";
import RecieveMoneyRight from "./RecieveMoneyRight";

const RecieveMoney = () => {
  return (
    <RecieveMoneyContainer>
      <RecieveMoneyLeft />
      <RecieveMoneyRight />
    </RecieveMoneyContainer>
  );
};

export default RecieveMoney;
